// Helpers for displaying a patient's identity document (NIN for Algerian patients,
// passport for foreign / diaspora patients).

export interface PatientIdFields {
  identityType?: 'NIN' | 'PASSPORT' | null;
  ninLast4?: string | null;
  passportLast4?: string | null;
}

// Returns an i18n key for the identifier type and the masked last-4 value,
// e.g. { typeKey: 'patient.ninShort', masked: '****1234' }.
export function patientIdentifier(p: PatientIdFields): { typeKey: string; masked: string } {
  if (p.identityType === 'PASSPORT') {
    return {
      typeKey: 'patient.passportShort',
      masked: p.passportLast4 ? `****${p.passportLast4}` : '—',
    };
  }
  return {
    typeKey: 'patient.ninShort',
    masked: p.ninLast4 ? `****${p.ninLast4}` : '—',
  };
}
